import moment from "moment-timezone";
import { ENV_CONFIG } from '../../../../constants/envConfig';
import { COUNTRY_LIST } from '../constants';
import { logError } from '../../../global/utils/logger';
import config from '../../../App/config';
import { logGRError, refreshTokenCall } from '../../utils/guidedUtil';
import { updateJoinCashFlag } from '../../api/apiRequest';
import { STORAGE_CONFIG } from '../../../../constants/storageConfig';
/**
 * Generates a list of states based on the country code.
 *
 * @param {string} countryCode - The country code for which the state list is generated
 * @return {Array} The list of states based on the country code
 */
export const generateStateList = countryCode => {
    const stateJson = require('../../../../constants/config.json');
    const stateArray = stateJson['STATES'][0][countryCode];
    if (countryCode == COUNTRY_LIST[1].value) {
        const validStateList = ENV_CONFIG.VALID_STATE_LIST;
        const validStateListArray = validStateList.split(',');
        return stateArray.filter(state => {
            if (validStateListArray.includes(state?.label) || validStateListArray.includes(state?.value)) {
                return state;
            }
        });
    }
    return stateArray;
};

/**
 * Retrieves alterable data from ENV_CONFIG and returns parsed common and account screen configurations.
 *
 * @return {Object} Object containing parsed common and account screen configurations.
 */
export const getAEMCashFlowAlterableData = () => {
    try {
        const { CASH_WORKFLOW_DATA: { commonconfigs = '', accountscreenconfigs = '' } = {} } = ENV_CONFIG || {};
        return { commonConfig: JSON.parse(commonconfigs), accountScreenConfig: JSON.parse(accountscreenconfigs) };
    } catch (error) {
        logError(error);
        return {};
    }
};

export const getAEMPersonalInfoData = () => {
    try {
        const { CASH_WORKFLOW_DATA: { commonconfigs = '', personalscreenconfigs = '' } = {} } = ENV_CONFIG || {};
        return { commonConfig: JSON.parse(commonconfigs), personalScreenConfig: JSON.parse(personalscreenconfigs) };
    } catch (error) {
        logError(error);
        return {};
    }
};

export const getJoinAccountData = () => {
    try {
        const { JOIN_WORKFLOW_DATA: { screenconfigs = '' } = {} } = ENV_CONFIG || {};
        return { screenConfig: JSON.parse(screenconfigs) };
    } catch (error) {
        logError(error);
        return {};
    }
};

export const navigateToPath = (navigate, path) => {
    navigate(`${config.pagePaths.cashWorkflow}${path}`);
};

export const getApplicationStatus = () => {
    try {
        const { CASHFLOW_APPLICATION_STATUS: { applicationstatusconfigs = '' } = {} } = ENV_CONFIG || {};
        return { applicationstatusconfig: JSON.parse(applicationstatusconfigs) };
    } catch (error) {
        logError(error);
        return {};
    }
};

export const getDriverLicenseNumberForCanada = () => {
    return moment().utc().format('MMDDYYYY-HHmmss');
};

export const updateJoinCashFailedFlag = async () => {
    try {
        await refreshTokenCall();
        const response = await updateJoinCashFlag(sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.GR_EMAIL));
        return response;
    } catch (error) {
        logError(error, false, 'POST', { requestType: 'Join Cash - Marketo Call' });
        return {};
    }
};
